import { PlanningAPI } from "../../axios";

export const actions = {

    // RatingScale
    GetRatingScale(context, data){
        return PlanningAPI.get(`RatingScale/Target/${data}`);
    },
    GetSingleRatingScale(context, data){
        return PlanningAPI.get(`RatingScale/${data}`);
    },
    UpdateRatingScale(context, data){
        return PlanningAPI.put(`RatingScale`, data);
    },
    DeleteRatingScale(context, data){
        return PlanningAPI.delete(`RatingScale/${data}`);
    },
    AddRatingScale(context, data){
        return PlanningAPI.post(`RatingScale`, data);
    },
    PostRatingScale(context, data){
        return PlanningAPI.post(`RatingScale/Post/${data}`);
    },
    ReturnRatingScale(context, data){
        return PlanningAPI.post(`RatingScale/Return/${data}`);
    },

}